const en = {
    request_pin_success: "Request PIN is successful. A pin was sent to your email address. Please use the PIN in that message to set your password.",
    register_success: "Your registration is complete. Next, you will need to set your password in order to login."
};

export default en;